module.exports = __webpack_public_path__ + "img/zjkp.d4bc28f7.png";